import Axios from "axios";

const test = false;

const baseUrlPre = "https://preint-zaracom.inditex.com";
const baseUrlPro = "https://www.zara.com/";
const path = "/integration/pressapi/itxrest/3/presslab/news";
const pathShowroom = "/itxrest/3/presslab/news";
const pathDetail = "/integration/pressapi/itxrest/4/presslab/news";
const pathShowroomDetail = "/itxrest/4/presslab/news";

const getUrl = (originURL, isShowroom) => {
  if (test) {
    return baseUrlPre + path;
  } else if (isShowroom) {
    return originURL + pathShowroom;
  }
  return originURL + path;
};

const getUrlDetail = (originURL, isShowroom) => {
  if (test) {
    return baseUrlPre + pathDetail;
  } else if (isShowroom) {
    return originURL + pathShowroomDetail;
  }
  return originURL + pathDetail;
};

export const getList = async (
  originURL,
  isShowroom,
  countryCode,
  page,
  limit,
  locale,
  showDraft
) => {
  const finalUrl = getUrl(originURL, isShowroom);
  const result = await Axios.get(finalUrl, {
    params: { countryCode, page, limit, locale, draft: showDraft },
  });

  return result;
};

export const getDetail = async (
  originURL,
  isShowroom,
  id,
  countryCode,
  locale,
  showDraft
) => {
  const finalUrl = getUrlDetail(originURL, isShowroom);
  const result = await Axios.get(`${finalUrl}/${id}`, {
    params: { countryCode, locale, draft: showDraft },
  });

  return result;
};

export const getProducts = async (originURL, categoryId) => {
  let url;
  if (test) {
    url =
      "https://preint-zaracom.inditex.com/integration/pressapi/integration/1/presslab/en/en/category/2025945/products";
  } else {
    url = `${originURL}/category/${categoryId}/products`;
  }
  const result = await Axios.get(`${url}`);

  return result;
};
